/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/6/25 14:34
 * @des BroadcastChannel 封装
 */
import {isNull} from './objutil'

var pageChannels = {}

/**
 * 向频道发送消息
 * @param pageId 页面id
 * @param name 频道名
 * @param data 发送数据
 */
export function postMessage (pageId, name, data) {
  try {
    var bc = createIfNot(pageId, name)
    bc.postMessage(data)
  } catch (e) {
    console.log('该浏览器暂不支持BroadcastChannel')
  }
}

/**
 * 监听频道消息
 * @param pageId 页面id
 * @param name 频道名
 * @param callback 结果返回
 */
export function onmessage (pageId, name, callback) {
  try {
    var bc = createIfNot(pageId, name)
    bc.onmessage = callback
  } catch (e) {
    console.log('该浏览器暂不支持BroadcastChannel')
  }
}

/**
 * 关闭当前页面频道
 * @param pageId 页面id
 * @param name 频道名
 */
export function close (pageId, name) {
  if (!isNull(pageChannels[pageId]) && !isNull(pageChannels[pageId][name])) {
    pageChannels[pageId][name].close()
    pageChannels[pageId][name] = null
  }
}

/**
 * 关闭所有广播
 * @param pageId
 */
export function closeAll (pageId) {
  let pageIdChannels = pageChannels[pageId]
  if (!isNull(pageIdChannels)) {
    Object.keys(pageIdChannels).forEach((name) => {
      let channel = pageIdChannels[name]
      if (channel) {
        channel.close()
        pageIdChannels[name] = null
      }
    })
  }
  pageChannels[pageId] = null
}

function createIfNot (pageId, name) {
  var pageBroadcastChannel = pageChannels[pageId]
  if (isNull(pageBroadcastChannel)) {
    pageBroadcastChannel = {}
    pageChannels[pageId] = pageBroadcastChannel
  }
  var broadcastChannel = pageBroadcastChannel[name]
  if (isNull(broadcastChannel)) {
    broadcastChannel = new BroadcastChannel(name)
    pageBroadcastChannel[name] = broadcastChannel
  }
  return broadcastChannel
}



// WEBPACK FOOTER //
// ./src/base/util/broadcastchannel.js